export function hideLinks(vm) {
	let links = vm.$el.querySelectorAll('.' + vm.listitemClassName);
	vm.numberOfHiddenLinks = 0;
	for (let i = 0; i < links.length; i++) {
		if (i >= vm.numberOfDisplayedLinks) {
			let currentLink = links[i];

			currentLink.classList.add(vm.hiddenClassName);
			vm.numberOfHiddenLinks++;
		}
	}
}

export function displayLinks(vm) {
	let links = vm.$el.querySelectorAll('.' + vm.listitemClassName + '.' + vm.hiddenClassName);

	for (let i = 0; i < links.length; i++) {
		let currentLink = links[i];

		currentLink.classList.remove(vm.hiddenClassName);
	}

	vm.numberOfHiddenLinks = 0;
}



// WEBPACK FOOTER //
// ../source/modules/FOO01-footer/FOO01-footer-links/FOO01-footer-links-utils.js